import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0945eb53&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0945eb53",
  null
  
)

export default component.exports